import Vue from 'vue'
import VeeValidate from 'vee-validate'
import { messages as frOriginalMessages } from 'vee-validate/dist/locale/fr'
import { messages as nlOriginalMessages } from 'vee-validate/dist/locale/nl'
import { messages as deOriginalMessages } from 'vee-validate/dist/locale/de'
import frMessages from './messages/messages.fr.js'
import nlMessages from './messages/messages.nl.js'
import deMessages from './messages/messages.de.js'
import frAttributes from './attributes/attributes.fr.json'
import nlAttributes from './attributes/attributes.nl.json'
import deAttributes from './attributes/attributes.de.json'
import validators from './validators'
import frCustomStandardMessages from './standard-messages/messages.fr.js'

export default {
  configure(currentLocale) {
    Vue.use(VeeValidate, {
      inject: false,
      locale: currentLocale,
      dictionary: {
        fr: { messages: { ...frOriginalMessages, ...frMessages, ...frCustomStandardMessages }, attributes: frAttributes },
        nl: { messages: { ...nlOriginalMessages, ...nlMessages }, attributes: nlAttributes },
        de: { messages: { ...deOriginalMessages, ...deMessages }, attributes: deAttributes }
      }
    })

    VeeValidate.Validator.extend('ean-code', validators.eanCode)
    VeeValidate.Validator.extend('reference-number', validators.referenceNumber)
    VeeValidate.Validator.extend('meter-number', validators.meterNumber)
    VeeValidate.Validator.extend('index-value', validators.indexValue)
    VeeValidate.Validator.extend('greater-than', validators.greaterThan)
    VeeValidate.Validator.extend('gsm-number', validators.gsmNumber)
    VeeValidate.Validator.extend('landline-number', validators.landlineNumber)
    VeeValidate.Validator.extend('max-digits', validators.maxDigits)
    VeeValidate.Validator.extend('only-letters', validators.onlyLetters)
    VeeValidate.Validator.extend('re-captcha', validators.reCaptcha)
    VeeValidate.Validator.extend('no-accents', validators.noAccents)
    VeeValidate.Validator.extend('no-special-chars-email', validators.noSpecialCharsEmail)
  }
}
